import script from "./Show.vue?vue&type=script&setup=true&lang=ts"
export * from "./Show.vue?vue&type=script&setup=true&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=ce4409fc&scoped=true&lang=css"
script.__scopeId = "data-v-ce4409fc"

export default script